export default "__VITE_ASSET__D0TA65Xf__"